export default "__VITE_ASSET__1Ry5WLb3__"